import React, { useState, useEffect, memo } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { 
  User, Briefcase, FileText, AlertCircle, Calendar, DollarSign, CreditCard, Save, Plus, Upload, Eye, Download 
} from 'lucide-react';
import config from '../config/config';

const InputField = memo(({ label, value, onChange, type = "text" }) => {
  return (
    <div className="space-y-2">
      <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide">
        {label}
      </label>
      <input
        type={type}
        value={value || ''}
        onChange={onChange}
        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
      />
    </div>
  );
});



export default function EmployeeProfile() {
  const navigate = useNavigate();
  const setActiveTab2 = (e) => {
  navigate('/employees');
}
  const { id } = useParams();
    const [activeTab, setActiveTab] = useState('bio');
    const [benefitAmounts,setBenefitAmounts]=useState({});
  const [employee, setEmployee] = useState({
    bio: { firstName: '', lastName: '', email: '', phone: '', dateOfBirth: '', nationality: '', idNumber: '' },
    hr: { department: '', department_id: '', position: '', employeeId: '', joinDate: '', employmentType: '', basic_salary: '', kra_pin: '', shif_number: '', nssf_number: '', branch: '', bank: '', employee_code: '', system_role: '' },
    contracts: [],
    disciplinary: [],
    leave: { balance: 0, taken: 0, records: [] },
    documents: [],
    advanceSalaries: [],
    loans: []
  });
  const [departments, setDepartments] = useState([]);
  const [Benefits, setBenefits] = useState([]);
  const [newItems, setNewItems] = useState({
    contract: { title: '', startDate: '', endDate: '', status: 'Active' },
    disciplinary: { date: '', type: '', reason: '', status: 'Open' },
    leaveRecord: { type: '', startDate: '', endDate: '', days: 0, status: 'Pending' },
    document: { name: '', type: '', file: null, fileName: '' },
    advanceSalary: { amount: 0, date: '', installments: 1 },
    loan: { amount: 0, date: '', installments: 1 }
  });
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewItems(prev => ({
        ...prev,
        document: {
          ...prev.document,
          file: file,
          fileName: file.name,
          name: prev.document.name || file.name.split('.')[0] // auto-fill name
        }
      }));
    }
  };

  const mapEmployeeData = (data) => {
    return {
      bio: {
        firstName: data.bio.first_name || '',
        lastName: data.bio.last_name || '',
        email: data.bio.email || '',
        phone: data.bio.contact || '',
        dateOfBirth: data.bio.dateOfBirth || '',
        nationality: data.bio.nationality || '',
        idNumber: data.bio.nationalId || '',
      },
      
      hr: {
        department: data.hr.department || '',
        position: data.hr.position || '',
         basic_salary: data.hr.basic_salary || '',
          shif_number: data.hr.shif_number || '',
           kra_pin: data.hr.kra_pin || '',
            nssf_number: data.hr.nssf_number || '',
             bank: data.hr.bank || '',
              branch: data.hr.branch || '',
               employee_code: data.hr.employee_code || '',
               system_role: data.hr.system_role || '',
          employeeId: data.hr.employeeId || '',
        joinDate: data.hr.joinDate || '',
        employmentType: data.hr.employmentType || '',
      },
      contracts: (data.contracts || []).map(c => ({
        id: c.id,
        title: c.title,
        startDate: c.startDate,
        endDate: c.endDate,
        status: c.status,
      })),
      disciplinary: (data.disciplinary || []).map(d => ({
        id: d.id,
        date: d.date,
        type: d.type,
        reason: d.reason,
        status: d.status,
      })),
      leave: {
        balance: data.leave?.balance ?? 0,
        taken: data.leave?.taken ?? 0,
        records: (data.leave?.records || []).map(r => ({
          id: r.id,
          type: r.type,
          startDate: r.startDate,
          endDate: r.endDate,
          days: r.days,
          status: r.status,
        })),
      },
      documents: (data.documents || []).map(d => ({
        id: d.id,
        name: d.name,
        uploadDate: d.uploadDate,
        file_url:d.file_url,
        type: d.type,
      })),
      advanceSalaries: (data.advanceSalaries || []).map(a => ({
        id: a.id,
        amount: a.amount,
        date: a.date,
        installments: a.installments,
        paid: a.paid || 0,
        status: a.status,
      })),
      loans: (data.loans || []).map(l => ({
        id: l.id,
        amount: l.amount,
        date: l.date,
        installments: l.installments,
        paid: l.paid || 0,
        balance: l.balance || 0,
        status: l.status,
      })),
    };
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('No token found');
      return;
    }

    async function fetchAll() {
      setLoading(true);
      try {
        const empRes = await axios.get(`${config.API_URL}/api/employeeDetails/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        let emp = mapEmployeeData(empRes.data.employee);

        const depRes = await axios.get(`${config.API_URL}/api/pullemployees`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const deps = depRes.data.departments || [];
        const benefitz = empRes.data.employee.benefits || [];
        setDepartments(deps);
        setBenefits(benefitz);

        const depId = deps.find(d => d.name === emp.hr.department)?.id || '';
        emp = { ...emp, hr: { ...emp.hr, department_id: depId } };

        setEmployee(emp);
      } catch (err) {
        console.error('Fetch error:', err);
      } finally {
        setLoading(false);
      }
    }

    fetchAll();
  }, [id]);

  const updateField = (section, field, value) => {
    setEmployee(prev => ({
      ...prev,
      [section]: { ...prev[section], [field]: value }
    }));
  };

  const updateAmountField = (section, value) => {
    setBenefitAmounts(prev => ({
      ...prev,
      [section]: { ...prev[section], value }
    }));
  };

  const addItem = async (section) => {
    let itemKey;



     if (section === 'documents') {
      const { name, type, file } = newItems.document;

      if (!name || !type || !file) {
        alert('Please provide document name, type, and select a file.');
        return;
      }

      setUploading(true);

      try {
        await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

        const getCookie = (name) => {
          const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
          if (match) return decodeURIComponent(match[2]);
          return null;
        };
        const xsrfToken = getCookie("XSRF-TOKEN");

        const formData = new FormData();
        formData.append('employee_id', id);
        formData.append('name', name);
        formData.append('type', type);
        formData.append('file', file);

        const response = await axios.post(`${config.API_URL}/api/store-employee-document`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'X-XSRF-TOKEN': xsrfToken,
          },
          withCredentials: true,
        });

        const newDoc = {
          id: response.data.id,
          name: response.data.name || name,
          type: response.data.type || type,
          uploadDate: response.data.upload_date || new Date().toISOString().split('T')[0],
          file_url: response.data.file_url // assuming backend returns the URL
        };

        setEmployee(prev => ({
          ...prev,
          documents: [...prev.documents, newDoc]
        }));

        // Reset form
        setNewItems(prev => ({
          ...prev,
          document: { name: '', type: '', file: null, fileName: '' }
        }));
        // Reset file input
        document.getElementById('file-input').value = '';


 } catch (err) {
        console.error('Upload error:', err);
        alert('Failed to upload document. Check console.');
      } finally {
        setUploading(false);
      }

      return; // exit early
    }

    if (section === 'leave.records') itemKey = 'leaveRecord';
    else if (section === 'advanceSalaries') itemKey = 'advanceSalary';
    else itemKey = section.replace(/s$/, '');

    const newId = section === 'leave.records' 
      ? (employee.leave.records.length + 1) 
      : (employee[section].length + 1);

    const newItem = { ...newItems[itemKey], id: newId };

    try {
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const getCookie = (name) => {
        const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
        if (match) return decodeURIComponent(match[2]);
        return null;
      };
      const xsrfToken = getCookie("XSRF-TOKEN");

      let endpoint;
      let payload;

      if (section === 'contracts') {
        endpoint = `${config.API_URL}/api/store-contract`;
        payload = {
          employee_id: id,
          title: newItem.title,
          start_date: newItem.startDate,
          end_date: newItem.endDate,
          status: newItem.status,
        };
      } else if (section === 'disciplinary') {
        endpoint = `${config.API_URL}/api/store-disciplinary-record`;
        payload = {
          employee_id: id,
          date: newItem.date,
          type: newItem.type,
          reason: newItem.reason,
          status: newItem.status,
        };
      } else if (section === 'leave.records') {
        endpoint = `${config.API_URL}/api/store-leave-record`;
        payload = {
          employee_id: id,
          type: newItem.type,
          start_date: newItem.startDate,
          end_date: newItem.endDate,
          days: newItem.days,
          status: newItem.status,
        };
      } else if (section === 'documents') {
        endpoint = `${config.API_URL}/api/store-employee-document`;
        payload = {
          employee_id: id,
          name: newItem.name,
          type: newItem.type,
        };
      } else if (section === 'advanceSalaries') {
        endpoint = `${config.API_URL}/api/store-salary-advance`;
        payload = {
          employee_id: id,
          amount: newItem.amount,
          date: newItem.date,
          installments: newItem.installments,
        };
      } else if (section === 'loans') {
        endpoint = `${config.API_URL}/api/store-loan`;
        payload = {
          employee_id: id,
          amount: newItem.amount,
          date: newItem.date,
          installments: newItem.installments,
        };
      }

      const response = await axios.post(endpoint, payload, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-XSRF-TOKEN": xsrfToken,
        },
        withCredentials: true,
      });

      if (response.data.id) {
        newItem.id = response.data.id;
      }

      if (section === 'leave.records') {
        setEmployee(prev => ({
          ...prev,
          leave: { ...prev.leave, records: [...prev.leave.records, newItem] }
        }));
      } else {
        setEmployee(prev => ({ ...prev, [section]: [...prev[section], newItem] }));
      }
    } catch (err) {
      console.error('Add item error:', err);
    }

    setNewItems(prev => ({
      ...prev,
      [itemKey]: itemKey === 'loan' || itemKey === 'advanceSalary'
        ? { amount: 0, date: '', installments: 1 }
        : itemKey === 'leaveRecord'
        ? { type: '', startDate: '', endDate: '', days: 0, status: 'Pending' }
        : itemKey === 'document'
        ? { name: '', type: '' }
        : itemKey === 'disciplinary'
        ? { date: '', type: '', reason: '', status: 'Open' }
        : { title: '', startDate: '', endDate: '', status: 'Active' }
    }));
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const getCookie = (name) => {
        const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
        if (match) return decodeURIComponent(match[2]);
        return null;
      };
      const xsrfToken = getCookie("XSRF-TOKEN");

      const payload = {
        first_name: employee.bio.firstName,
        last_name: employee.bio.lastName,
        email: employee.bio.email,
        contact: employee.bio.phone,
        nationalId: employee.bio.idNumber,
        date_of_birth: employee.bio.dateOfBirth,
        nationality: employee.bio.nationality,
        department_id: employee.hr.department_id,
        position: employee.hr.position,
        basic_salary: employee.hr.basic_salary,
        shif_number: employee.hr.shif_number,
        kra_pin: employee.hr.kra_pin,
        nssf_number: employee.hr.nssf_number,
        bank: employee.hr.bank,
        branch: employee.hr.branch,
        employee_code: employee.hr.employee_code,
        join_date: employee.hr.joinDate,
        employment_type: employee.hr.employmentType,
        benefitAmounts:benefitAmounts,
      };

      await axios.put(`${config.API_URL}/api/updateemployees/${id}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-XSRF-TOKEN": xsrfToken,
        },
        withCredentials: true,
      });

      console.log('Saved successfully');
    } catch (err) {
      console.error('Save error:', err);
    } finally {
      setLoading(false);
    }
  };

  const tabs = [
    { id: 'bio', label: 'Personal', icon: User },
    { id: 'hr', label: 'HR Details', icon: Briefcase },
    { id: 'contracts', label: 'Contracts', icon: FileText },
    { id: 'disciplinary', label: 'Disciplinary', icon: AlertCircle },
    { id: 'leave', label: 'Leave', icon: Calendar },
    { id: 'documents', label: 'Documents', icon: FileText },
    { id: 'advanceSalaries', label: 'Advances', icon: DollarSign },
    { id: 'loans', label: 'Loans', icon: CreditCard }
  ];

  if (loading) {
    return <div className="min-h-screen bg-white flex items-center justify-center text-lg">Loading...</div>;
  }

  return (
  <div className="min-h-screen bg-gray-50">
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-9xl mx-auto px-4 sm:px-6 lg:px-8 shadow-lg">
          <div className="flex justify-between items-center py-6 bg-gray-50 max-w-9xl">
          <div className="" >
            <h1 className="text-3xl font-semibold text-gray-900 mb-2">
              {employee.bio.firstName} {employee.bio.lastName}
            </h1>
            <p className="text-sm text-gray-500 mt-1 mb-2">
              {employee.hr.position} • {employee.hr.employeeId}
            </p>
          </div>
          <button
            onClick={handleSave}
            disabled={loading}
            className="flex mb-2 items-center gap-2 px-6 py-3 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors shadow-sm disabled:opacity-50"
          >
            <Save className="w-4 h-4" />
            {loading ? 'Saving...' : 'Save Changes'}
          </button>
        </div>

        <div className="mb-8">
          <div className="flex max-w-9xl gap-2 p-1 bg-gray-900 rounded-lg inline-flex" style={{ width:`100%`}}>
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-md transition-all text-white ${
                    activeTab === tab.id
                      ? 'bg-white text-gray-900 shadow-sm'
                      : 'text-white-600 hover:text-gray-900'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {tab.label}
                </button>
              );
            })}
           
                 <button
                 
                  onClick={() => setActiveTab2('payroll') }
                  className={`flex items-center gap-2 px-4 py-2.5 bg-red-700 text-white text-sm font-medium rounded-md transition-all`}
                >
                  
                  Back To HR
                </button>
          </div>
        </div>

        {/* Rest of your JSX remains exactly the same */}
        {/* Only change is using the memoized InputField defined outside */}

        <div className="space-y-12">
          {activeTab === 'bio' && (
            <div className="max-w-7xl">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">Personal Information</h2>
              <div className="grid grid-cols-2 gap-6">
                <InputField label="First Name" value={employee.bio.firstName} onChange={(e) => updateField('bio', 'firstName', e.target.value)} />
                <InputField label="Last Name" value={employee.bio.lastName} onChange={(e) => updateField('bio', 'lastName', e.target.value)} />
                <InputField label="Email Address" type="email" value={employee.bio.email} onChange={(e) => updateField('bio', 'email', e.target.value)} />
                <InputField label="Phone Number" value={employee.bio.phone} onChange={(e) => updateField('bio', 'phone', e.target.value)} />
                <InputField label="Date of Birth" type="date" value={employee.bio.dateOfBirth} onChange={(e) => updateField('bio', 'dateOfBirth', e.target.value)} />
                <InputField label="Nationality" value={employee.bio.nationality} onChange={(e) => updateField('bio', 'nationality', e.target.value)} />
                <InputField label="ID Number" value={employee.bio.idNumber} onChange={(e) => updateField('bio', 'idNumber', e.target.value)} />
              <InputField label="KRA Pin" value={employee.hr.kra_pin} onChange={(e) => updateField('hr', 'kra_pin', e.target.value)} />
                 <InputField label="SHIF Number" value={employee.hr.shif_number} onChange={(e) => updateField('hr', 'shif_number', e.target.value)} />
                  <InputField label="NSSF Number" value={employee.hr.nssf_number} onChange={(e) => updateField('hr', 'nssf_number', e.target.value)} />
                <InputField label="Bank" value={employee.hr.bank} onChange={(e) => updateField('hr', 'bank', e.target.value)} />
                 <InputField label="Branch" value={employee.hr.branch} onChange={(e) => updateField('hr', 'branch', e.target.value)} />
               
              </div>
            </div>
          )}


          {/* Updated Documents Tab */}
          {activeTab === 'documents' && (
            <div className="max-w-9xl">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">Employee Documents</h2>
              <div className="space-y-4">
                {employee.documents.length === 0 ? (
                  <p className="text-gray-500 text-center py-8">No documents uploaded yet.</p>
                ) : (
                  employee.documents.map((doc) => (
                    <div key={doc.id} className="p-6 bg-gray-50 rounded-xl border border-gray-100 hover:bg-gray-100 transition">
                      <div className="grid grid-cols-4 gap-6 items-center">
                        <div>
                          <p className="text-xs font-medium text-gray-500 uppercase mb-2">Name</p>
                          <p className="font-medium">{doc.name}</p>
                        </div>
                        <div>
                          <p className="text-xs font-medium text-gray-500 uppercase mb-2">Type</p>
                          <p>{doc.type}</p>
                        </div>
                        <div>
                          <p className="text-xs font-medium text-gray-500 uppercase mb-2">Uploaded</p>
                          <p>{doc.uploadDate}</p>
                        </div>
                        <div className="flex gap-2">
                          
                            <>
                              <a
                                href={`${config.API_URL}/storage/${doc.file_url}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="p-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition"
                                title="View"
                              >
                                <Eye className="w-4 h-4" />
                              </a>
                              <a
                                href={`${config.API_URL}/storage/${doc.file_url}`}
                                target="_blank"
                                download
                                className="p-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition"
                                title="Download"
                              >
                                <Download className="w-4 h-4" />
                              </a>
                            </>
                        
                        </div>
                      </div>
                    </div>
                  ))
                )}

                {/* Upload Form */}
                <div className="p-6 border-2 border-dashed border-gray-300 rounded-xl bg-gray-50">
                  <div className="flex items-center gap-2 mb-6">
                    <Upload className="w-5 h-5 text-gray-600" />
                    <p className="text-lg font-medium text-gray-700">Upload New Document</p>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                    <InputField
                      label="Document Name"
                      value={newItems.document.name}
                      onChange={(e) => setNewItems(p => ({
                        ...p,
                        document: { ...p.document, name: e.target.value }
                      }))}
                    />
                   
                     <select
                   value={newItems.document.type}
                      onChange={(e) => setNewItems(p => ({
                        ...p,
                        document: { ...p.document, type: e.target.value }
                      }))}
                  
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  >
                    <option value="">Select Document Type</option>
                   
                      <option>National Id</option>
                      <option>Passport</option>
                      <option>Birth certificate

</option>
                      <option>Resume / CV

</option>
                      <option>Employment contract

</option>
                      <option>Non-disclosure agreement (NDA)

</option><option>Health/life insurance



</option><option>Performance reviews



</option><option>Training certificates 



</option>
<option>Warning letter

 



</option>
<option>Disciplinary letter





</option>
<option>Termination

 letter





</option>
                   
                  </select>
                    <div className="space-y-2">
                      <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide">
                        Select File
                      </label>
                      <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-400 rounded-lg cursor-pointer bg-white hover:border-blue-500 transition">
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                          <Upload className="w-8 h-8 text-gray-400 mb-2" />
                          <p className="text-sm text-gray-600">
                            {newItems.document.fileName || 'Click to select file'}
                          </p>
                          <p className="text-xs text-gray-500 mt-1">PDF, JPG, PNG, DOCX up to 10MB</p>
                        </div>
                        <input
                          id="file-input"
                          type="file"
                          className="hidden"
                          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                          onChange={handleFileSelect}
                        />
                      </label>
                    </div>
                  </div>

                  <button
                    onClick={() => addItem('documents')}
                    disabled={uploading}
                    className="w-full md:w-auto px-8 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  >
                    {uploading ? (
                      <>Uploading...</>
                    ) : (
                      <>
                        <Upload className="w-4 h-4" />
                        Upload Document
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'hr' && (
            <div className="max-w-9xl">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">HR Details</h2>
              <div className="grid grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide">Department</label>
                  <select
                    value={employee.hr.department_id || ''}
                    onChange={(e) => {
                      const newId = e.target.value;
                      const newName = departments.find(d => d.id == newId)?.name || '';
                      setEmployee(prev => ({
                        ...prev,
                        hr: { ...prev.hr, department_id: newId, department: newName }
                      }));
                    }}
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  >
                    <option value="">Select Department</option>
                    {departments.map(dep => (
                      <option key={dep.id} value={dep.id}>{dep.name}</option>
                    ))}
                  </select>
                </div>
              
                <InputField label="Role" readonly value={employee.hr.system_role} onChange={(e) => updateField('hr', 'position', e.target.value)} />
 
                <InputField label="Employee Code" value={employee.hr.employee_code} onChange={(e) => updateField('hr', 'employee_code', e.target.value)} />
                <InputField label="Join Date" type="date" value={employee.hr.joinDate} onChange={(e) => updateField('hr', 'joinDate', e.target.value)} />
             
                <select
                   value={employee.hr.employmentType} onChange={(e) => updateField('hr', 'employmentType', e.target.value)}
                  
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  >
                    <option value="">Select Employment Type</option>
                   
                      <option>Contract</option>
                      <option>Permanent</option>
                      <option>Probation</option>
                      <option>Internship</option>
                      <option>Attachment</option>
                      <option>Casual</option>
                   
                  </select>
               
             
              </div>
              <br/>
                <hr/>
                 <br/>
                 <InputField label="Basic Salary" value={employee.hr.basic_salary} onChange={(e) => updateField('hr', 'basic_salary', e.target.value)} />
            <br/>
            <div className="">
 <br />

    {/* Benefits Amount Allocation */}
    <div>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Custom Benefits / Deductions Allocation</h3>
      
      {Benefits.length === 0 ? (
        <p className="text-gray-500">No benefits defined in the system.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {Benefits.map((benefit) => (
            <InputField
              key={benefit.id}
              label={`${benefit.name} Amount - [${benefit.type}]`}
              type="number"
              value={benefitAmounts[benefit.id] || benefit.amount}  // pulls saved or typed value
              onChange={(e) => {
                const value = e.target.value;
                setBenefitAmounts(prev => ({
                  ...prev,
                  [benefit.id]: value === '' ? null : parseFloat(value) || ''
                }));
              }}
              placeholder="0.00"
            />
          ))}
        </div>
      )}
    </div>

  

   
  </div>
            </div>
          )}

           {/* Contracts */}
          {activeTab === 'contracts' && (
            <div className="max-w-9xl">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">Contracts</h2>
              <div className="space-y-4">
                {employee.contracts.map((contract) => (
                  <div key={contract.id} className="p-6 bg-gray-50 rounded-xl border border-gray-100">
                    <div className="grid grid-cols-4 gap-6">
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Title</p><p>{contract.title}</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Start</p><p>{contract.startDate}</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">End</p><p>{contract.endDate}</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Status</p>
                        <span className={`inline-flex px-3 py-1 text-xs font-medium rounded-full ${contract.status === 'Active' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}`}>
                          {contract.status}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="p-6 border-2 border-dashed border-gray-200 rounded-xl">
                  <div className="flex items-center gap-2 mb-4">
                    <Plus className="w-4 h-4 text-gray-400" />
                    <p className="text-sm font-medium text-gray-600">Add New Contract</p>
                  </div>
                  <div className="grid grid-cols-4 gap-4">
                    <input placeholder="Title" value={newItems.contract.title} onChange={(e) => setNewItems(p => ({...p, contract: {...p.contract, title: e.target.value}}))} className="px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <input type="date" value={newItems.contract.startDate} onChange={(e) => setNewItems(p => ({...p, contract: {...p.contract, startDate: e.target.value}}))} className="px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <input type="date" value={newItems.contract.endDate} onChange={(e) => setNewItems(p => ({...p, contract: {...p.contract, endDate: e.target.value}}))} className="px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <button onClick={() => addItem('contracts')} className="px-4 py-3 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700">Add</button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Disciplinary Records */}
          {activeTab === 'disciplinary' && (
            <div className="max-w-9xl">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">Disciplinary Records</h2>
              <div className="space-y-4">
                {employee.disciplinary.map((record) => (
                  <div key={record.id} className="p-6 bg-red-50 rounded-xl border border-red-200">
                    <div className="grid grid-cols-4 gap-6">
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Date</p><p>{record.date}</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Type</p><p>{record.type}</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Reason</p><p>{record.reason}</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Status</p>
                        <span className={`inline-flex px-3 py-1 text-xs font-medium rounded-full ${record.status === 'Resolved' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                          {record.status}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="p-6 border-2 border-dashed border-gray-200 rounded-xl">
                  <div className="flex items-center gap-2 mb-4">
                    <Plus className="w-4 h-4 text-gray-400" />
                    <p className="text-sm font-medium text-gray-600">Add New Record</p>
                  </div>
                  <div className="grid grid-cols-4 gap-4">
                    <input type="date" value={newItems.disciplinary.date} onChange={(e) => setNewItems(p => ({...p, disciplinary: {...p.disciplinary, date: e.target.value}}))} className="px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    
                <select
                  value={newItems.disciplinary.type} onChange={(e) => setNewItems(p => ({...p, disciplinary: {...p.disciplinary, type: e.target.value}}))}
                  
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  >
                    <option value="">Select Disciplinary Type</option>
                   
                      <option>Attendance and Punctuality Issues

</option>
                      <option>Performance Problems

</option>
                      <option>Misconduct or Behavioral Violations

</option>
                      <option>Harassment and Discrimination

</option>
                      <option>Theft, Fraud, or Dishonesty

</option>
                      <option>Violence, Threats, or Safety Violations

</option>
<option>Confidentiality or Conflict of Interest Breaches



</option>
<option>Other</option>

                   
                  </select>

                    <textarea placeholder="Type disciplinary reason" value={newItems.disciplinary.reason} onChange={(e) => setNewItems(p => ({...p, disciplinary: {...p.disciplinary, reason: e.target.value}}))} className="px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">{newItems.disciplinary.reason}</textarea>
                    <button onClick={() => addItem('disciplinary')} className="px-4 py-3 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700">Add</button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Leave Management */}
          {activeTab === 'leave' && (
            <div className="max-w-9xl">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">Leave Management</h2>
              <div className="grid grid-cols-3 gap-6 mb-8">
                <div className="p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl">
                  <p className="text-xs font-medium text-blue-600 uppercase mb-2">Total Balance</p>
                  <p className="text-4xl font-bold text-blue-900">{employee.leave.balance}</p>
                  <p className="text-sm text-blue-700 mt-1">days available</p>
                </div>
                <div className="p-6 bg-gradient-to-br from-green-50 to-green-100 rounded-xl">
                  <p className="text-xs font-medium text-green-600 uppercase mb-2">Taken</p>
                  <p className="text-4xl font-bold text-green-900">{employee.leave.taken}</p>
                  <p className="text-sm text-green-700 mt-1">days used</p>
                </div>
                <div className="p-6 bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl">
                  <p className="text-xs font-medium text-purple-600 uppercase mb-2">Remaining</p>
                  <p className="text-4xl font-bold text-purple-900">{employee.leave.balance - employee.leave.taken}</p>
                  <p className="text-sm text-purple-700 mt-1">days left</p>
                </div>
              </div>
              <div className="space-y-4">
                {employee.leave.records.map((record) => (
                  <div key={record.id} className="p-6 bg-gray-50 rounded-xl border border-gray-100">
                    <div className="grid grid-cols-5 gap-6">
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Type</p><p>{record.type}</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Start</p><p>{record.startDate}</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">End</p><p>{record.endDate}</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Days</p><p>{record.days} days</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Status</p>
                        <span className={`inline-flex px-3 py-1 text-xs font-medium rounded-full ${record.status === 'Approved' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>
                          {record.status}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="p-6 border-2 border-dashed border-gray-200 rounded-xl">
                  <div className="flex items-center gap-2 mb-4">
                    <Plus className="w-4 h-4 text-gray-400" />
                    <p className="text-sm font-medium text-gray-600">Apply for Leave</p>
                  </div>
                  <div className="grid grid-cols-5 gap-4">
                   <select
                 value={newItems.leaveRecord.type} onChange={(e) => setNewItems(p => ({...p, leaveRecord: {...p.leaveRecord, type: e.target.value}}))}
                  
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  >
                    <option value="">Select Leave Type</option>
                   
                      <option>Annual Leave

</option>
                      <option>Sick Leave

</option>
                      <option>Maternity Leave

</option>
                      <option>Paternity Leave

</option>
                      <option>Compassionate Leave

</option>
                      <option>Public Holidays

</option>
<option>Casual Leave



</option>
<option>Family Leave



</option>
                   
                  </select>
                  
                    <input type="date" value={newItems.leaveRecord.startDate} onChange={(e) => setNewItems(p => ({...p, leaveRecord: {...p.leaveRecord, startDate: e.target.value}}))} className="px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <input type="date" value={newItems.leaveRecord.endDate} onChange={(e) => setNewItems(p => ({...p, leaveRecord: {...p.leaveRecord, endDate: e.target.value}}))} className="px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                   
                    <button onClick={() => addItem('leave.records')} className="px-4 py-3 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700">Add</button>
                  </div>
                </div>
              </div>
            </div>
          )}

        

          {/* Salary Advances */}
          {activeTab === 'advanceSalaries' && (
            <div className="max-w-9xl">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">Salary Advances</h2>
              <div className="space-y-4">
                {employee.advanceSalaries.map((advance) => (
                  <div key={advance.id} className="p-6 bg-teal-50 rounded-xl border border-teal-200">
                    <div className="grid grid-cols-5 gap-6">
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Amount</p><p>KES {advance.amount}</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Date</p><p>{advance.date}</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Installments</p><p>{advance.installments} months</p></div>
                      <div>
                        <p className="text-xs font-medium text-gray-500 uppercase mb-2">Progress</p>
                        <div className="flex items-center gap-2">
                          <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                            <div className="h-full bg-teal-600 rounded-full" style={{width: `${(advance.paid / advance.installments) * 100}%`}} />
                          </div>
                          <p className="text-xs text-gray-600">{advance.paid}/{advance.installments}</p>
                        </div>
                      </div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Status</p>
                        <span className="inline-flex px-3 py-1 text-xs font-medium bg-teal-100 text-teal-700 rounded-full">{advance.status}</span>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="p-6 border-2 border-dashed border-gray-200 rounded-xl">
                  <div className="flex items-center gap-2 mb-4">
                    <Plus className="w-4 h-4 text-gray-400" />
                    <p className="text-sm font-medium text-gray-600">Record New Advance</p>
                  </div>
                  <div className="grid grid-cols-4 gap-4">
                    <input type="number" placeholder="Amount (KES)" value={newItems.advanceSalary.amount} onChange={(e) => setNewItems(p => ({...p, advanceSalary: {...p.advanceSalary, amount: parseInt(e.target.value) || 0}}))} className="px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <input type="date" value={newItems.advanceSalary.date} onChange={(e) => setNewItems(p => ({...p, advanceSalary: {...p.advanceSalary, date: e.target.value}}))} className="px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <input type="number" placeholder="Installments" value={newItems.advanceSalary.installments} onChange={(e) => setNewItems(p => ({...p, advanceSalary: {...p.advanceSalary, installments: parseInt(e.target.value) || 1}}))} className="px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <button onClick={() => addItem('advanceSalaries')} className="px-4 py-3 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700">Add</button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Loans */}
          {activeTab === 'loans' && (
            <div className="max-w-9xl">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">Loans</h2>
              <div className="space-y-4">
                {employee.loans.map((loan) => (
                  <div key={loan.id} className="p-6 bg-orange-50 rounded-xl border border-orange-200">
                    <div className="grid grid-cols-6 gap-6">
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Amount</p><p>KES {loan.amount}</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Date</p><p>{loan.date}</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Installments</p><p>{loan.installments} months</p></div>
                      <div>
                        <p className="text-xs font-medium text-gray-500 uppercase mb-2">Progress</p>
                        <div className="flex items-center gap-2">
                          <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                            <div className="h-full bg-orange-500 rounded-full" style={{width: `${(loan.paid / loan.installments) * 100}%`}} />
                          </div>
                          <p className="text-xs text-gray-600">{loan.paid}/{loan.installments}</p>
                        </div>
                      </div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Balance</p><p className="text-orange-600 font-medium">KES {loan.balance}</p></div>
                      <div><p className="text-xs font-medium text-gray-500 uppercase mb-2">Status</p>
                        <span className="inline-flex px-3 py-1 text-xs font-medium bg-orange-100 text-orange-700 rounded-full">{loan.status}</span>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="p-6 border-2 border-dashed border-gray-200 rounded-xl">
                  <div className="flex items-center gap-2 mb-4">
                    <Plus className="w-4 h-4 text-gray-400" />
                    <p className="text-sm font-medium text-gray-600">Record New Loan</p>
                  </div>
                  <div className="grid grid-cols-4 gap-4">
                    <input type="number" placeholder="Amount (KES)" value={newItems.loan.amount} onChange={(e) => setNewItems(p => ({...p, loan: {...p.loan, amount: parseInt(e.target.value) || 0}}))} className="px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <input type="date" value={newItems.loan.date} onChange={(e) => setNewItems(p => ({...p, loan: {...p.loan, date: e.target.value}}))} className="px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <input type="number" placeholder="Installments" value={newItems.loan.installments} onChange={(e) => setNewItems(p => ({...p, loan: {...p.loan, installments: parseInt(e.target.value) || 1}}))} className="px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <button onClick={() => addItem('loans')} className="px-4 py-3 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700">Add</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
     </div>
  );
}